<template>
	
<div class="more">

	<div class="more-title">{{ section.treatment.more.title }}</div>

	<com-benefits :section="section" :treatment="treatment" />
	<com-chances :section="section" :treatment="treatment" />
	<com-risk :section="section" :treatment="treatment" />
	<div class="more-explainer" v-if="$isPatient && hasScore && section.treatment.more.explainer_risk"><i class="fa-solid fa-circle-info more-explainer-icon"></i><div class="more-explainer-text" v-html="section.treatment.more.explainer_risk"></div></div>
	<com-detail :section="section" :treatment="treatment" />
	<div class="more-explainer" v-if="$isPatient && section.treatment.more.explainer_effects"><i class="fa-solid fa-circle-info more-explainer-icon"></i><div class="more-explainer-text" v-html="section.treatment.more.explainer_effects"></div></div>
	<com-contact v-if="!$isPatient" :section="section" :treatment="treatment" />
	<com-practical :section="section" :treatment="treatment" />
	<div class="more-explainer" v-if="$isPatient && treatment === 'bisphosphonates' && section.treatment.more.explainer_practical"><i class="fa-solid fa-circle-info more-explainer-icon"></i><div class="more-explainer-text" v-html="section.treatment.more.explainer_practical"></div></div>

	<div class="more-buttons" v-if="!$isPatient">
		<com-button v-on:click="$emit('close')">Back</com-button>
		<com-button v-on:click="$emit('next')">Continue</com-button>
	</div>

</div>

</template>

<script>

import comButton from './../../../common/Button'

import comBenefits from './more/Benefits'
import comChances from './more/Chances'
import comRisk from './more/Risk'
import comDetail from './more/Detail'
import comContact from './more/Contact'
import comPractical from './more/Practical'

export default {

	props: ['section', 'treatment'],

	components: {
		'com-button': comButton,
		'com-benefits': comBenefits,
		'com-chances': comChances,
		'com-risk': comRisk,
		'com-detail': comDetail,
		'com-contact': comContact,
		'com-practical': comPractical
	},

	computed: {

		hasScore: function() {

			return this.frax('major') !== 0

		}

	},

	methods: {

		onBackClick: function() {



		}

	}
	
}

</script>

<style scoped>

.more-title {
	color: #343434;
	font-size: 24px;
	font-weight: 600;
	margin-bottom: 32px;
	margin-left: 32px;
}

.more-buttons {
	display: flex;
	justify-content: center;
}

.more-buttons >>> button {
	margin: 0px 10px;
}

</style>

<style>

.more-explainer {
	background-color: var(--aid-color);
	border-radius: 17px;
	padding: 20px 40px 20px 56px;
	margin-bottom: 16px;
	font-size: 16px;
	line-height: 24px;
	color: #343434;
	font-weight: 600;
	position: relative;
}

.more-explainer-icon {
	position: absolute;
	left: 20px;
	top: 20px;
	font-size: 20px;
	color: #343434;
}

.more-explainer p { margin-bottom: 8px; }
.more-explainer p:last-child { margin-bottom: 0; }

</style>